module.exports = __webpack_public_path__ + "img/chef.43804cf3.jpg";